<div>
    <ng-template #logout>
        <form #logoutForm="ngForm" (ngSubmit)="onSignout()">
            <button
                id="logoutButton"
                mat-menu-item
                style="font-size: 14px; color: red;"
            >
                Logout
            </button>
        </form>
    </ng-template>
    <ng-template #login>
        <div>
            <button id="signInButton" mat-menu-item (click)="openDialog()">
                Sign In
            </button>
        </div>
    </ng-template>
    <div *ngIf="token$ | async as token; else login">
        <div *ngIf="!!token; then logout; else login"></div>
    </div>
</div>
